import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { Modal } from "antd";
import tw, { css } from "twin.macro";
import { hideScrollbar } from "../../lib/styles/styleLibrary";
import {
	EmptyData,
	GiftItem,
	NewGiftItems,
	ProductItem,
} from "../../components";
import { useQuery } from "react-query";
import { fetchAllGifts } from "../../redux/actions/registry";
import { currencyFormat, isEmpty } from "../../lib/helpers/helpers";
import { useMediaQuery } from "react-responsive";
import { PageLoading } from "../../components";
import Auth from "../../lib/middleware/auth";

const floatBtn = (props) => css`
	${tw`absolute font-bold bg-appPink flex items-center justify-center rounded-full border-none text-white h-12 w-12 hover:(shadow-lg cursor-pointer)`}
	bottom: 1.5rem;
	right: 1.5rem;
	font-size: 2rem;
	box-shadow: 0px 10px 35px rgba(241, 94, 95, 0.25);
`;

const Gifts = (props) => {
	const { weddingId, couple } = props;
	const experience = Auth.getExperience();
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const [visible, setVisible] = useState(false);
	const [viewItem, setViewItem] = useState(false);
	const [selectedItem, setSelectedItem] = useState({});

	const {
		data: giftData,
		isLoading,
		refetch,
	} = useQuery(["gifts", { weddingId }], () => fetchAllGifts({ weddingId }), {
		refetchOnWindowFocus: false,
		enabled: !isEmpty(weddingId),
	});
	const gifts = giftData?.data?.wedding_gifts;

	return (
		<div
			tw="overflow-y-scroll"
			style={{ height: "calc(100vh - 12rem)" }}
			css={hideScrollbar}>
			<div tw="flex flex-col md:flex-row flex-wrap gap-5 mb-8">
				{isLoading ? (
					<PageLoading />
				) : isEmpty(gifts) ? (
					<div tw="h-full w-full">
						<EmptyData />
					</div>
				) : (
					gifts?.map((item, i) => {
						return (
							<ProductItem
								selectedItem={selectedItem}
								setSelectedItem={setSelectedItem}
								setViewItem={setViewItem}
								key={i}
								item={item}
								src={item?.wedding_gifts_images[0]?.media_url}
								name={item.name}
								price={currencyFormat(item.price)}
								gifted={item.is_fulfilled}
								store={item.store}
								gift_link={item.gift_link}
							/>
						);
					})
				)}

				<Modal
					footer=""
					visible={visible}
					centered
					onCancel={() => setVisible(false)}
					maskClosable={false}>
					<NewGiftItems
						tw="p-0!"
						weddingID={couple?.id}
						couple={couple}
						setVisible={setVisible}
						refetch={refetch}
					/>
				</Modal>
				<Modal
					footer=""
					visible={viewItem}
					width={isMobile ? "100%" : "55%"}
					centered
					onCancel={() => setViewItem(false)}
					maskClosable={false}>
					<GiftItem
						item={selectedItem}
						togView={setViewItem}
						refetch={refetch}
						weddingID={weddingId}
					/>
				</Modal>
				{experience === "couple" && (
					<button css={floatBtn} onClick={() => setVisible(true)}>
						+
					</button>
				)}
			</div>
		</div>
	);
};

export default Gifts;
